import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import "./Theme.css";
import "./EasiScore.css";

const REGIONS = [
  { key: "easi.regions.headNeck", value: "Head & Neck" },
  { key: "easi.regions.hands", value: "Hands" },
  { key: "easi.regions.trunkGenitals", value: "Trunk & Genitals" },
  { key: "easi.regions.legs", value: "Legs" },
];

const EasiQ1 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const uuid = urlParams.get("uuid") || "";
  const goqiiUserId = getGoqiiUserId();
  const nonce = urlParams.get("nonce") || "";
  const apiKey = urlParams.get("apiKey") || "";
  const signature = urlParams.get("signature") || "";
  const goqiiAccessToken = urlParams.get("goqiiAccessToken") || "";

  const [selectedRegions, setSelectedRegions] = useState([]);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  const toggleRegion = (value) => {
    setSelectedRegions((prev) =>
      prev.includes(value) ? prev.filter((r) => r !== value) : [...prev, value]
    );
  };

  const buildQs = () =>
    `uuid=${uuid}&goqiiuserid=${goqiiUserId}&nonce=${nonce}&apiKey=${apiKey}&signature=${signature}&goqiiAccessToken=${goqiiAccessToken}&theme=${theme}&lang=${lang}`;

  const handleNext = () => {
    if (selectedRegions.length === 0) return;
    navigate(`/easi-score?${buildQs()}`);
  };

  return (
    <>
      <section className="easi-page">
        <div className="easi-container">
          <div className="easi-question-block">
            <label className="easi-label">{t("easi.selectRegionTitle")}</label>
            <div className="easi-region-list">
              {REGIONS.map(({ key, value }) => (
                <label key={value} className="easi-region-item">
                  <input
                    type="checkbox"
                    checked={selectedRegions.includes(value)}
                    onChange={() => toggleRegion(value)}
                  />
                  <span
                    className={`easi-checkbox-box${selectedRegions.includes(value) ? " checked" : ""}`}
                  />
                  <span className="easi-region-label">{t(key)}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="easi-bottom-btn">
        <button
          type="button"
          className="easi-btn-done"
          disabled={selectedRegions.length === 0}
          onClick={handleNext}
        >
          {t("easi.nextBtn")}
        </button>
      </section>
    </>
  );
};

export default EasiQ1;
